// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3fa7a02a","743":"514a2f15"}[chunkId] + ".chunk.js";
};